module.exports = __webpack_public_path__ + "img/Gilroy-ExtraBold.2f3a04be.svg";